<router-outlet></router-outlet>
<!--@if (configService.configuration.useMockHttp) {-->
<!--  <testing-layout></testing-layout>-->
<!--}-->
@if (isShowErrorModal) {
  <error-modal (onClose)="closeErrorModal()"></error-modal>
}
